import React from "react";

export default function About() {
  return (
    <section id="about" className="section section--surface">
      <div className="section-inner">
        <div className="about__content">
          <div>
            <p className="about__label">About</p>
            <h2 className="about__title">The Story</h2>
            <p className="about__lede">
              MemoryAgent started as a continuity problem, then became a trust
              problem.
            </p>
            <div className="about__text">
              <p>
                I grew up as a gamer in an era when getting something to work
                usually meant troubleshooting it first. You learned by tracing
                problems, testing assumptions, and figuring out how systems
                actually fit together. That mindset stuck with me.
              </p>
              <p>
                Years later, while working as a web developer, I kept thinking
                about how much context disappears between tasks. I wanted an
                assistant that did not need constant explanations, one that
                could quietly track real work as it happened and help me resume
                without breaking flow.
              </p>
              <p>
                That idea evolved into something larger. If a system can observe
                enough to preserve continuity, it can also help reason through
                problems in a more objective way. That is what pushed
                MemoryAgent beyond a shadowing assistant and toward explicit
                plans, machine-checkable verification, and replayable evidence
                instead of black-box guesses.
              </p>
              <p>
                As the sole founder and engineer, I built the system end to end
                around that belief. The honest wedge today is developers,
                technical operators, and macOS power users who need agents that
                do real work reliably. Everything else builds from there.
              </p>
            </div>
          </div>
          <div className="about__image-wrapper">
            <img
              className="about__image"
              src="./assets/images/about.jpg"
              alt="Korey Collazo"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
